export const getAuthToken = () => localStorage.getItem('auth_token');
export const setAuthToken = token => localStorage.setItem('auth_token', token);
export const removeAuthToken = () => localStorage.removeItem('auth_token');

// REMEMBER ME LOGIN
export const getRememberData = () => localStorage.getItem('remember_data');
export const setRememberData = data => localStorage.setItem('remember_data', data);
export const removeRememberData = () => localStorage.removeItem('remember_data');